<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M17.936,4.9421a6.0364,6.0364,0,0,0-11.8728,0H2.4973V24H21.5027V4.9421ZM12,1.25a4.7918,4.7918,0,0,1,4.6523,3.6921H7.3477A4.7918,4.7918,0,0,1,12,1.25Zm8.2527,21.5H3.7473V6.1921H20.2527Z"/></svg>
</template>